import { useMachineSettingsDialogState } from 'components/sections/admin-portal/machines/hooks/useMachineSettingsDialogState';
import { MachineSettingsQueryParams } from 'enums/machine-settings';
import {
  IMachineSettingsDateFilter,
  IMachineSettingsURLParams,
} from 'interfaces/i-machine-settings';
import { IMissedDetectionsTableFilters } from 'interfaces/i-machine-shots-history-table';

export const useMachineMissedDetectionsDialogState = () => {
  const { getParams, setParams } = useMachineSettingsDialogState();

  const searchParams = getParams();

  const missedDetectionID = searchParams.get(
    MachineSettingsQueryParams.MissedDetectionID
  );

  const missedDetectionPitchName = searchParams.get(
    MachineSettingsQueryParams.MissedDetectionPitchName
  );
  const missedDetectionMessage = searchParams.get(
    MachineSettingsQueryParams.MissedDetectionMessage
  );

  const missedDetectionDateStart = searchParams.get(
    MachineSettingsQueryParams.MissedDetectionDateStart
  );
  const missedDetectionDateEnd = searchParams.get(
    MachineSettingsQueryParams.MissedDetectionDateEnd
  );

  const missedDetectionFilters: IMissedDetectionsTableFilters = {
    pitchName: missedDetectionPitchName || '',
    message: missedDetectionMessage || '',
    dateRange:
      missedDetectionDateStart && missedDetectionDateEnd
        ? {
            start: new Date(missedDetectionDateStart),
            end: new Date(missedDetectionDateEnd),
          }
        : undefined,
  };

  const setMissedDetectionsFilters = (
    v: Partial<IMissedDetectionsTableFilters>
  ) => {
    const updated: Partial<IMachineSettingsURLParams> = {};

    for (const k in v) {
      const key = k as keyof IMissedDetectionsTableFilters;
      const value = v[key];

      switch (key) {
        case 'dateRange': {
          if (!value) {
            updated[MachineSettingsQueryParams.MissedDetectionDateStart] =
              undefined;
            updated[MachineSettingsQueryParams.MissedDetectionDateEnd] =
              undefined;
            break;
          }

          const dateRange = value as IMachineSettingsDateFilter;

          updated[MachineSettingsQueryParams.MissedDetectionDateStart] =
            dateRange.start.toISOString();
          updated[MachineSettingsQueryParams.MissedDetectionDateEnd] =
            dateRange.end.toISOString();
          break;
        }

        case 'pitchName':
          if (!value) {
            updated[MachineSettingsQueryParams.MissedDetectionPitchName] =
              undefined;
            break;
          }

          updated[MachineSettingsQueryParams.MissedDetectionPitchName] =
            value as string;
          break;

        case 'message':
          if (!value) {
            updated[MachineSettingsQueryParams.MissedDetectionMessage] =
              undefined;
            break;
          }

          updated[MachineSettingsQueryParams.MissedDetectionMessage] =
            value as string;
          break;

        default:
          break;
      }
    }

    setParams(updated, 'setMissedDetectionsFilters');
  };

  const setMissedDetectionID = (id: string) => {
    setParams(
      {
        [MachineSettingsQueryParams.MissedDetectionID]: id,
      },
      'setMissedDetectionID'
    );
  };

  const resetMissedDetectionID = () => {
    setParams(
      {
        [MachineSettingsQueryParams.MissedDetectionID]: undefined,
      },
      'resetMissedDetectionID'
    );
  };

  return {
    missedDetectionID,
    setMissedDetectionID,
    resetMissedDetectionID,
    missedDetectionFilters,
    setMissedDetectionsFilters,
  };
};
